function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var html2canvas = require('html2canvas');
var SaitoVideoBox = require('../saito-videobox/video-box');
var StreamCapturer = /*#__PURE__*/function () {
  function StreamCapturer(app, mod, logo) {
    var _this = this;
    _classCallCheck(this, StreamCapturer);
    this.combinedStream = null;
    this.streamData = [];
    this.activeStreams = new Map();
    this.app = app;
    this.mod = mod;
    // this.logo = logo;
    this.view_window = '.video-container-large';
    this.handleResize = this.handleResize.bind(this);
    console.log('********************', 'Use Stream Capturer', '***********************');
    app.connection.on('stun-track-event', function (peerId, event) {
      console.log('stun-track-event', peerId);
      if (event.streams.length === 0 && event !== null && event !== void 0 && event.track) {
        _this.processTrack(event.track);
      } else {
        event.streams[0].getTracks().forEach(function (track) {
          _this.processTrack(track);
        });
      }
      console.log(_this.activeStreams, 'activestreams');
    });
    app.connection.on('start-stun-call', function (event) {
      if (_this.localStream) {
        _this.localStream.getAudioTracks().forEach(function (track) {
          _this.removeAudioTrack(track.id);
          track.stop();
        });
        _this.localStream = null;
      }

      // remove existing video box, this will now be handled by the videocall module
      _this.removeVideoBox(true);

      // remove video and audio controls in lite dream controls, this is now handled by videocall module
      var controlList = document.querySelector('#dream-controls .control-panel .control-list');
      if (controlList) {
        var videoControl = controlList.querySelector('i.fas.fa-video, i.fas.fa-video-slash');
        var audioControl = controlList.querySelector('i.fas.fa-microphone, i.fas.fa-microphone-slash');
        if (videoControl) {
          videoControl.closest('.dream-controls-menu-item').classList.add('hidden-control');
        }
        if (audioControl) {
          audioControl.closest('.dream-controls-menu-item').classList.add('hidden-control');
        }
      }

      // get stream from media-request
      var checkForStream = function checkForStream() {
        var streams = _this.app.modules.getRespondTos('media-request');
        if (streams.length > 0 && streams[0].localStream) {
          _this.mediaRequestLocalStream = streams[0].localStream;
          _this.mediaRequestLocalStream.getAudioTracks().forEach(function (track) {
            _this.processAudioTrack(track);
          });
          return true;
        } else {
          return false;
        }
      };

      // Start checking for the stream
      var checkStreamInterval = setInterval(function () {
        if (checkForStream()) {
          // If checkForStream returns true, clear the interval to stop the loop
          clearInterval(checkStreamInterval);
        }
      }, 100); // Check every 100ms
    });
    app.connection.on('stun-disconnect', function () {
      var controlList = document.querySelector('#dream-controls .control-panel .control-list');
      if (controlList) {
        var videoControl = controlList.querySelector('.dream-controls-menu-item i.fas.fa-video, .dream-controls-menu-item i.fas.fa-video-slash');
        var audioControl = controlList.querySelector('.dream-controls-menu-item i.fas.fa-microphone, .dream-controls-menu-item i.fas.fa-microphone-slash');
        if (videoControl) {
          videoControl.closest('.dream-controls-menu-item').classList.remove('hidden-control');
          videoControl.classList.replace('fa-video', 'fa-video-slash');
        }
        if (audioControl) {
          audioControl.closest('.dream-controls-menu-item').classList.remove('hidden-control');
          audioControl.classList.replace('fa-microphone', 'fa-microphone-slash');
        }
      }
      if (_this.mediaRequestLocalStream) {
        _this.mediaRequestLocalStream.getAudioTracks().forEach(function (track) {
          console.log('removing audio track ', track);
          _this.removeAudioTrack(track.id);
          track.stop();
        });
      }
    });
    this.logo = new Image();
    this.logo.src = '/saito/img/logo.svg';
  }
  return _createClass(StreamCapturer, [{
    key: "processTrack",
    value: function processTrack(track) {
      if (track.kind === 'audio') {
        this.processAudioTrack(track);
      }
    }
  }, {
    key: "processAudioTrack",
    value: function processAudioTrack(track) {
      var stream = new MediaStream([track]);
      var trackId = track.id;
      if (!this.activeStreams.has(trackId)) {
        var source = this.audioCtx.createMediaStreamSource(stream);
        var gainNode = this.audioCtx.createGain();
        gainNode.gain.setValueAtTime(0.5, this.audioCtx.currentTime);
        source.connect(gainNode);
        gainNode.connect(this.mixer);
        this.activeStreams.set(trackId, {
          source: source,
          gainNode: gainNode,
          track: track
        });
      } else {
        console.log('track already exists', trackId);
      }
    }
  }, {
    key: "removeAudioTrack",
    value: function removeAudioTrack(trackId) {
      if (this.activeStreams.has(trackId)) {
        console.log('Removing audio track', trackId);
        var _this$activeStreams$g = this.activeStreams.get(trackId),
          source = _this$activeStreams$g.source,
          gainNode = _this$activeStreams$g.gainNode,
          track = _this$activeStreams$g.track;

        // Disconnect the source and gain node
        source.disconnect();
        gainNode.disconnect();

        // Stop the track
        track.stop();

        // Remove the track from the active streams
        this.activeStreams["delete"](trackId);
        console.log('Audio track removed and disconnected', trackId);
      } else {
        console.log('Track not found for removal', trackId);
      }
    }
  }, {
    key: "drawImageProp",
    value: function drawImageProp(ctx, img, x, y, w, h, offsetX, offsetY) {
      if (arguments.length === 2) {
        x = y = 0;
        w = ctx.canvas.width;
        h = ctx.canvas.height;
      }
      offsetX = typeof offsetX === 'number' ? offsetX : 0.5;
      offsetY = typeof offsetY === 'number' ? offsetY : 0.5;
      if (offsetX < 0) offsetX = 0;
      if (offsetY < 0) offsetY = 0;
      if (offsetX > 1) offsetX = 1;
      if (offsetY > 1) offsetY = 1;
      var iw = img.videoWidth || img.width,
        ih = img.videoHeight || img.height,
        r = Math.min(w / iw, h / ih),
        nw = iw * r,
        nh = ih * r,
        cx,
        cy,
        cw,
        ch,
        ar = 1;
      if (nw < w) ar = w / nw;
      if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;
      nw *= ar;
      nh *= ar;
      cw = iw / (nw / w);
      ch = ih / (nh / h);
      cx = (iw - cw) * offsetX;
      cy = (ih - ch) * offsetY;
      if (cx < 0) cx = 0;
      if (cy < 0) cy = 0;
      if (cw > iw) cw = iw;
      if (ch > ih) ch = ih;
      ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h);
      this.drawLogoOnCanvas(ctx);
    }
  }, {
    key: "serializeNode",
    value: function serializeNode(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        return {
          type: 'text',
          content: node.textContent
        };
      }
      if (node.nodeType === Node.ELEMENT_NODE) {
        var serialized = {
          type: 'element',
          tagName: node.tagName,
          attributes: {},
          children: [],
          styles: {}
        };

        // Serialize attributes
        var _iterator = _createForOfIteratorHelper(node.attributes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var attr = _step.value;
            serialized.attributes[attr.name] = attr.value;
          }

          // Serialize computed styles
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var styles = window.getComputedStyle(node);
        var _iterator2 = _createForOfIteratorHelper(styles),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var style = _step2.value;
            serialized.styles[style] = styles.getPropertyValue(style);
          }

          // Serialize children
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        var _iterator3 = _createForOfIteratorHelper(node.childNodes),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var child = _step3.value;
            serialized.children.push(this.serializeNode(child));
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        return serialized;
      }
      return null;
    }
  }, {
    key: "drawLogoOnCanvas",
    value: function drawLogoOnCanvas(ctx) {
      var maxDimension = 100;
      var aspectRatio = this.logo.naturalWidth / this.logo.naturalHeight;
      var logoWidth, logoHeight;
      if (this.logo.naturalWidth > this.logo.naturalHeight) {
        logoWidth = maxDimension;
        logoHeight = maxDimension / aspectRatio;
      } else {
        logoHeight = maxDimension;
        logoWidth = maxDimension * aspectRatio;
      }
      var logoX = ctx.canvas.width - logoWidth - 50;
      var logoY = ctx.canvas.height - logoHeight - 10;
      this.logo.style.objectFit = 'cover';
      ctx.drawImage(this.logo, logoX, logoY, logoWidth, logoHeight);
    }
  }, {
    key: "resizeCanvas",
    value: function resizeCanvas(canvas) {
      console.log('resizing canvas');
      canvas.width = window.innerWidth;
      canvas.height = document.querySelector(this.view_window).clientHeight;
      var videoElements = document.querySelectorAll('div[id^="stream_"] video');
      this.drawStreamsToCanvas();
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      this.resizeCanvas(this.canvas);
    }
  }, {
    key: "captureVideoCallStreams",
    value: function captureVideoCallStreams() {
      var _this2 = this;
      var includeCamera = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.is_capturing_stream) {
        console.log('RECORD --- Nope out of resetting captureVideoCallStreams');
        return this.combinedStream;
      }
      try {
        this.combinedStream = new MediaStream();
        this.is_capturing_stream = true;
        var view_window = document.querySelector(this.view_window);
        if (!view_window) {
          console.warn('No valid screen input');
          return;
        }

        // Delete all canvas's on the screen (can break games!)
        document.querySelectorAll('canvas').forEach(function (canvas) {
          canvas.parentElement.removeChild(document.querySelector('canvas'));
        });
        this.audioCtx = new AudioContext();
        this.destination = new MediaStreamAudioDestinationNode(this.audioCtx);
        this.mixer = this.audioCtx.createGain();
        this.mixer.connect(this.destination);
        if (includeCamera) {
          this.observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function (node) {
                  if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'DIV' && node.id.startsWith('stream_')) {
                    var videos = node.querySelectorAll('video');
                    videos.forEach(function (video) {
                      console.log('new video element', video);
                      var stream = 'captureStream' in video ? video.captureStream() : 'mozCaptureStream' in video ? video.mozCaptureStream() && video.mozCaptureStream(0) : null;
                      var rect = video.getBoundingClientRect();
                      var parentID = video.parentElement.id;
                      var existingVideoIndex = _this2.streamData.findIndex(function (data) {
                        return data.video.id === video.id;
                      });
                      if (existingVideoIndex !== -1) {
                        console.log('Video exists');
                        _this2.streamData[existingVideoIndex] = {
                          stream: stream,
                          rect: rect,
                          parentID: parentID,
                          video: video
                        };
                        return;
                      }
                      _this2.streamData.push({
                        stream: stream,
                        rect: rect,
                        parentID: parentID,
                        video: video
                      });
                    });
                  }
                });
                if (mutation.removedNodes.length > 0) {
                  mutation.removedNodes.forEach(function (node) {
                    if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'DIV' && node.id.startsWith('stream_')) {
                      var videos = node.querySelectorAll('video');
                      videos.forEach(function (video) {
                        var streamData = _this2.streamData.find(function (data) {
                          return data.video.id === video.id;
                        });
                        if (streamData) {
                          _this2.streamData = _this2.streamData.filter(function (data) {
                            return data.video.id !== video.id;
                          });
                        }
                      });
                    }
                  });
                }
              }
              if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                _this2.streamData.forEach(function (data) {
                  if (data.parentID === mutation.target.id) {
                    data.rect = mutation.target.getBoundingClientRect();
                  }
                });
              }
            });
          });

          //Start Observer
          this.observer.observe(view_window, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['style']
          });
          var canvas = document.createElement('canvas');
          this.canvas = canvas;
          canvas.width = window.innerWidth;
          canvas.height = view_window.clientHeight;
          var ctx = canvas.getContext('2d');
          console.log('Canvas Dimensions: ', canvas.width, canvas.height);
          var _drawStreamsToCanvas = function drawStreamsToCanvas() {
            if (!_this2.is_capturing_stream) return;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            _this2.streamData.forEach(function (data) {
              var parentElement = document.getElementById(data.parentID);
              if (!parentElement) return;
              var rect = parentElement.getBoundingClientRect();
              // Draw the video on the canvas
              if (data.video.readyState >= 2) {
                _this2.drawImageProp(ctx, data.video, rect.left, rect.top, rect.width, rect.height);
              }
            });
            // console.log('still drawing streams');
            _this2.animationFrameId = requestAnimationFrame(_drawStreamsToCanvas);
          };
          this.drawStreamsToCanvas = _drawStreamsToCanvas;
          var self = this;
          window.addEventListener('resize', this.handleResize);
          this.resizeCanvas(canvas);
          var videoElements = document.querySelectorAll(this.view_window + ' div[id^="stream_"] video');
          // console.log('video elements', videoElements)
          this.streamData = Array.from(videoElements).map(function (video) {
            var stream = 'captureStream' in video ? video.captureStream() : 'mozCaptureStream' in video ? video.mozCaptureStream() : null;

            // processStream(stream, video);
            var rect = video.getBoundingClientRect();
            var parentID = video.parentElement.id;
            return {
              stream: stream,
              rect: rect,
              parentID: parentID,
              video: video
            };
          }).filter(function (data) {
            return data.stream !== null;
          });
          var streams = this.app.modules.getRespondTos('media-request');
          if ((streams === null || streams === void 0 ? void 0 : streams.length) > 0) {
            this.localStream = streams[0].localStream;
            this.additionalSources = streams[0].remoteStreams;
            if (this.localStream.getAudioTracks().length > 0) {
              var localAudio = this.audioCtx.createMediaStreamSource(this.localStream);
              localAudio.connect(this.mixer);
            }
            this.additionalSources.forEach(function (value, key) {
              var otherAudio = _this2.audioCtx.createMediaStreamSource(value);
              otherAudio.connect(_this2.mixer);
            });
          }
          this.combinedStream.addTrack(canvas.captureStream(25).getVideoTracks()[0]);
        } else {
          this.observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function (node) {
                  if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'DIV' && node.id.startsWith('stream_')) {
                    var videos = node.querySelectorAll('video');
                    videos.forEach(function (video) {
                      var stream = 'captureStream' in video ? video.captureStream() : 'mozCaptureStream' in video ? video.mozCaptureStream() : null;
                      // processStream(stream, video);
                      var existingVideoIndex = _this2.streamData.findIndex(function (data) {
                        return data.video.id === video.id;
                      });
                      if (existingVideoIndex !== -1) {
                        console.log('Video exists');
                        _this2.streamData[existingVideoIndex] = {
                          stream: stream,
                          video: video
                        };
                        return;
                      }
                      _this2.streamData.push({
                        stream: stream,
                        video: video
                      });
                    });
                  }
                });
                if (mutation.removedNodes.length > 0) {
                  mutation.removedNodes.forEach(function (node) {
                    if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'DIV' && node.id.startsWith('stream_')) {
                      var videos = node.querySelectorAll('video');
                      videos.forEach(function (video) {
                        var streamData = _this2.streamData.find(function (data) {
                          return data.video.id === video.id;
                        });
                        if (streamData) {
                          console.log('removed stream from source', streamData.stream.id);
                          removeStream(streamData.stream.id);
                          _this2.streamData = _this2.streamData.filter(function (data) {
                            return data.video.id !== video.id;
                          });
                        }
                      });
                    }
                  });
                }
              }
            });
          });
          this.observer.observe(view_window, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['style']
          });
          var _streams = this.app.modules.getRespondTos('media-request');
          if ((_streams === null || _streams === void 0 ? void 0 : _streams.length) > 0) {
            this.localStream = _streams[0].localStream;
            this.additionalSources = _streams[0].remoteStreams;
            if (this.localStream.getAudioTracks().length > 0) {
              var _localAudio = this.audioCtx.createMediaStreamSource(this.localStream);
              _localAudio.connect(this.mixer);
            }
            this.additionalSources.forEach(function (value, key) {
              var otherAudio = _this2.audioCtx.createMediaStreamSource(value);
              otherAudio.connect(_this2.mixer);
            });
          }
        }
        this.combinedStream.addTrack(this.destination.stream.getAudioTracks()[0]);
        return this.combinedStream;
      } catch (error) {
        console.log('Error capturing video streams', error);
      }
    }
  }, {
    key: "stopCaptureVideoCallStreams",
    value: function stopCaptureVideoCallStreams() {
      console.log('initiate cleanup');
      this.is_capturing_stream = false;
      cancelAnimationFrame(this.animationFrameId);
      window.removeEventListener('resize', this.handleResize);
      this.combinedStream.getTracks().forEach(function (track) {
        track.stop();
        console.log(track, 'track');
      });
      this.combinedStream = null;
      this.observer.disconnect();
      this.streamData = [];
      if (this.activeStreams) {
        this.activeStreams.forEach(function (_ref) {
          var source = _ref.source,
            gainNode = _ref.gainNode;
          source.disconnect();
        });
        this.activeStreams.clear();
      }
      if (this.canvas && this.canvas.parentNode) {
        this.canvas.parentNode.removeChild(this.canvas);
      }
    }
  }, {
    key: "captureGameStream",
    value: function () {
      var _captureGameStream = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this3 = this;
        var includeCamera,
          shortenAddress,
          getComputedFontStyle,
          view_window,
          canvas,
          ctx,
          lastScreenshot,
          _drawStreamsToCanvas2,
          lastCaptureTime,
          captureInterval,
          originalCreatePattern,
          _captureAndDraw,
          videoElements,
          _args2 = arguments,
          _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              getComputedFontStyle = function _getComputedFontStyle(element) {
                var computedStyle = window.getComputedStyle(element);
                return {
                  font: "".concat(computedStyle.fontStyle, " ").concat(computedStyle.fontWeight, " ").concat(computedStyle.fontSize, "/").concat(computedStyle.lineHeight, " ").concat(computedStyle.fontFamily),
                  color: computedStyle.color,
                  textAlign: computedStyle.textAlign,
                  textBaseline: computedStyle.verticalAlign === 'middle' ? 'middle' : 'alphabetic'
                };
              };
              shortenAddress = function _shortenAddress(address) {
                var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
                if (address.length <= maxLength) return address;
                var start = address.slice(0, Math.floor(maxLength / 2) - 1);
                // const end = address.slice(-Math.floor(maxLength / 2) + 1);
                return "".concat(start, "...");
              };
              includeCamera = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
              console.log(this.is_capturing_stream, includeCamera, 'details');
              this.combinedStream = new MediaStream();
              this.is_capturing_stream = true;
              view_window = document.querySelector(this.view_window);
              if (view_window) {
                _context2.n = 1;
                break;
              }
              console.warn('No valid screen input');
              return _context2.a(2);
            case 1:
              // clear previous canvas
              if (document.querySelector('#gameCanvasID')) {
                console.log('existing canvas');
                document.querySelector('#gameCanvasID').parentElement.removeChild(document.querySelector('#gameCanvasID'));
              }

              // create audio context and mixer
              this.audioCtx = new AudioContext();
              this.destination = new MediaStreamAudioDestinationNode(this.audioCtx);
              this.mixer = this.audioCtx.createGain();
              this.mixer.connect(this.destination);
              this.observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                  if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function (node) {
                      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'DIV' && node.id.startsWith('stream_')) {
                        var videos = node.querySelectorAll('video');
                        console.log('new video elements', videos);
                        videos.forEach(function (video) {
                          var stream = 'captureStream' in video ? video.captureStream() : 'mozCaptureStream' in video ? video.mozCaptureStream() && video.mozCaptureStream(0) : null;
                          var rect = video.getBoundingClientRect();
                          var parentID = video.parentElement.id;
                          var saitoAddressElement = video.closest('div[id^="stream_"]').querySelector('.saito-address');
                          var saitoAddress = saitoAddressElement ? shortenAddress(saitoAddressElement.textContent) : null;
                          var fontStyle = saitoAddressElement ? getComputedFontStyle(saitoAddressElement) : null;
                          var existingVideoIndex = _this3.streamData.findIndex(function (data) {
                            return data.video.id === video.id;
                          });
                          if (existingVideoIndex !== -1) {
                            _this3.streamData[existingVideoIndex] = {
                              stream: stream,
                              rect: rect,
                              parentID: parentID,
                              video: video,
                              saitoAddress: saitoAddress,
                              fontStyle: fontStyle
                            };
                            return;
                          }
                          _this3.streamData.push({
                            stream: stream,
                            rect: rect,
                            parentID: parentID,
                            video: video,
                            saitoAddress: saitoAddress
                          });
                        });
                      }
                    });
                    if (mutation.removedNodes.length > 0) {
                      mutation.removedNodes.forEach(function (node) {
                        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'DIV' && node.id.startsWith('stream_')) {
                          var videos = node.querySelectorAll('video');
                          videos.forEach(function (video) {
                            var streamData = _this3.streamData.find(function (data) {
                              return data.video.id === video.id;
                            });
                            if (streamData) {
                              _this3.streamData = _this3.streamData.filter(function (data) {
                                return data.video.id !== video.id;
                              });
                            }
                          });
                        }
                      });
                    }

                    // console.log('Updated Stream Data: ', this.streamData);
                  }
                  if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                    var videoContainer = mutation.target.closest('div[id^="stream_"]');
                    if (videoContainer) {
                      var video = videoContainer.querySelector('video');
                      var saitoAddressElement = videoContainer.querySelector('.saito-address');
                      if (video) {
                        var streamData = _this3.streamData.find(function (data) {
                          return data.video === video;
                        });
                        if (streamData) {
                          var rect = video.getBoundingClientRect();
                          streamData.rect = rect;
                          if (saitoAddressElement) {
                            streamData.saitoAddress = shortenAddress(saitoAddressElement.textContent);
                            streamData.fontStyle = getComputedFontStyle(saitoAddressElement);
                            var saitoRect = saitoAddressElement.getBoundingClientRect();
                            streamData.saitoAddressPosition = {
                              x: saitoRect.left - rect.left,
                              y: saitoRect.top - rect.top
                            };
                          } else {
                            streamData.saitoAddress = null;
                            streamData.saitoAddressPosition = null;
                            streamData.fontStyle = null;
                          }
                        }
                      }
                    }
                  }
                });
              });

              //Start Observer
              this.observer.observe(view_window, {
                attributes: true,
                childList: true,
                subtree: true,
                attributeFilter: ['style']
              });
              canvas = document.createElement('canvas');
              canvas.setAttribute('id', 'gameCanvasID');
              this.canvas = canvas;
              canvas.width = window.innerWidth;
              canvas.height = view_window.clientHeight;
              ctx = canvas.getContext('2d'); // console.log('Canvas Dimensions: ', canvas.width, canvas.height);
              lastScreenshot = null;
              _drawStreamsToCanvas2 = function drawStreamsToCanvas() {
                if (!_this3.is_capturing_stream) return;
                // Clear the canvas
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                // Draw the last captured screenshot if available
                if (lastScreenshot) {
                  ctx.drawImage(lastScreenshot, 0, 0, canvas.width, canvas.height);
                }
                // Draw video streams
                _this3.streamData.forEach(function (data) {
                  var parentElement = document.getElementById(data.parentID);
                  if (!parentElement) return;
                  var rect = parentElement.getBoundingClientRect();
                  // Draw the video on the canvas
                  if (data.video.readyState >= 2) {
                    _this3.drawImageProp(ctx, data.video, rect.left, rect.top, rect.width, rect.height);

                    // Draw saito address if available
                    if (data.saitoAddress && data.saitoAddressPosition && data.fontStyle) {
                      var x = data.rect.left + data.saitoAddressPosition.x;
                      var y = data.rect.top + data.saitoAddressPosition.y;
                      ctx.font = data.fontStyle.font;
                      ctx.fillStyle = data.fontStyle.color;
                      ctx.textAlign = data.fontStyle.textAlign;
                      ctx.textBaseline = data.fontStyle.textBaseline;

                      // Adding a subtle text shadow for better visibility
                      ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
                      ctx.shadowBlur = 2;
                      ctx.shadowOffsetX = 1;
                      ctx.shadowOffsetY = 1;
                      ctx.fillText(data.saitoAddress, x, y);

                      // Reset shadow
                      ctx.shadowColor = 'transparent';
                      ctx.shadowBlur = 0;
                      ctx.shadowOffsetX = 0;
                      ctx.shadowOffsetY = 0;
                    }
                  }
                });
                _this3.drawLogoOnCanvas(ctx);
                _this3.drawStreamsAnimationFrameId = requestAnimationFrame(_drawStreamsToCanvas2);
              };
              lastCaptureTime = 0;
              captureInterval = 1000 / 1;
              originalCreatePattern = CanvasRenderingContext2D.prototype.createPattern;
              CanvasRenderingContext2D.prototype.createPattern = function (image, repetition) {
                if (image instanceof HTMLCanvasElement && (image.width === 0 || image.height <= 1)) {
                  console.warn('Attempted to create pattern with problematic canvas:', image.width, image.height);
                  image.width = image.width || 2;
                  image.height = Math.max(image.height, 2);
                }
                return originalCreatePattern.call(this, image, repetition);
              };
              _captureAndDraw = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(timestamp) {
                  var public_key, rect, screenshot, _t;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.p = _context.n) {
                      case 0:
                        public_key = _this3.mod.publicKey;
                        if (_this3.is_capturing_stream) {
                          _context.n = 1;
                          break;
                        }
                        return _context.a(2);
                      case 1:
                        if (!(timestamp - lastCaptureTime >= captureInterval)) {
                          _context.n = 6;
                          break;
                        }
                        lastCaptureTime = timestamp;
                        rect = view_window.getBoundingClientRect();
                        _context.p = 2;
                        _context.n = 3;
                        return html2canvas(view_window, {
                          scale: 0.6,
                          useCORS: false,
                          allowTaint: false,
                          logging: false,
                          x: rect.left,
                          y: rect.top,
                          width: rect.width,
                          height: rect.height,
                          ignoreElements: function ignoreElements(element) {
                            var stream_id = "stream_".concat(public_key);
                            if (element.id === stream_id) {
                              return true;
                            }
                            if (element.classList.contains('stun-chatbox')) {
                              return true;
                            }
                            if (element.classList.contains('chat-container')) {
                              return true;
                            }
                            if (element.classList.contains('game-menu')) {
                              return true;
                            }
                            if (element.classList.contains('control-list')) {
                              return true;
                            }
                            if (element.classList.contains('yt-stream')) {
                              return true;
                            }
                          }
                        });
                      case 3:
                        screenshot = _context.v;
                        lastScreenshot = screenshot;
                        _context.n = 5;
                        break;
                      case 4:
                        _context.p = 4;
                        _t = _context.v;
                        console.error('Error capturing view_window:', _t);
                      case 5:
                        _context.p = 5;
                        return _context.f(5);
                      case 6:
                        _this3.captureAnimationFrameId = requestAnimationFrame(_captureAndDraw);
                      case 7:
                        return _context.a(2);
                    }
                  }, _callee, null, [[2, 4, 5, 6]]);
                }));
                return function captureAndDraw(_x) {
                  return _ref2.apply(this, arguments);
                };
              }();
              this.drawStreamsToCanvas = _drawStreamsToCanvas2;

              // Start both loops
              window.addEventListener('resize', this.handleResize);
              this.resizeCanvas(canvas);
              _captureAndDraw();
              videoElements = document.querySelectorAll(this.view_window + ' div[id^="stream_"] video'); // console.log('video elements', videoElements)
              this.streamData = Array.from(videoElements).map(function (video) {
                var stream = 'captureStream' in video ? video.captureStream() : 'mozCaptureStream' in video ? video.mozCaptureStream() : null;

                // processStream(stream, video);
                var rect = video.getBoundingClientRect();
                var parentID = video.parentElement.id;
                return {
                  stream: stream,
                  rect: rect,
                  parentID: parentID,
                  video: video
                };
              });
              this.combinedStream.addTrack(canvas.captureStream(30).getVideoTracks()[0]);

              // get existing streams
              _context2.p = 2;
              _context2.n = 3;
              return this.getExistingStreams(includeCamera);
            case 3:
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              console.error('Failed to get existing streams:', _t2);
              alert('An error occurred while setting up streams');
            case 5:
              this.combinedStream.addTrack(this.destination.stream.getAudioTracks()[0]);
              return _context2.a(2, this.combinedStream);
          }
        }, _callee2, this, [[2, 4]]);
      }));
      function captureGameStream() {
        return _captureGameStream.apply(this, arguments);
      }
      return captureGameStream;
    }()
  }, {
    key: "stopCaptureGameStream",
    value: function () {
      var _stopCaptureGameStream = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this4 = this;
        var streams, additionalSources, _iterator4, _step4, _step4$value, key, value, _iterator6, _step6, _track, _iterator5, _step5, track, _iterator7, _step7, _track2, _iterator8, _step8, _step8$value, _key, _value, _iterator9, _step9, _track3, _t3, _t4, _t5, _t6, _t7, _t8;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              console.log('initiate cleanup');
              this.is_capturing_stream = false;
              cancelAnimationFrame(this.drawStreamsAnimationFrameId);
              cancelAnimationFrame(this.captureAnimationFrameId);
              window.removeEventListener('resize', this.handleResize);

              // Check and cleanup streams
              // Cleanup streams
              streams = this.app.modules.getRespondTos('media-request');
              console.log('current streams', streams);
              if (!(streams.length > 0)) {
                _context3.n = 24;
                break;
              }
              additionalSources = streams[0].remoteStream;
              _iterator4 = _createForOfIteratorHelper(additionalSources);
              _context3.p = 1;
              _iterator4.s();
            case 2:
              if ((_step4 = _iterator4.n()).done) {
                _context3.n = 11;
                break;
              }
              _step4$value = _slicedToArray(_step4.value, 2), key = _step4$value[0], value = _step4$value[1];
              console.log(key, value.remoteStream.getAudioTracks());
              _iterator6 = _createForOfIteratorHelper(value.remoteStream.getAudioTracks());
              _context3.p = 3;
              _iterator6.s();
            case 4:
              if ((_step6 = _iterator6.n()).done) {
                _context3.n = 7;
                break;
              }
              _track = _step6.value;
              _context3.n = 5;
              return this.removeAudioTrack(_track.id);
            case 5:
              _track.stop();
            case 6:
              _context3.n = 4;
              break;
            case 7:
              _context3.n = 9;
              break;
            case 8:
              _context3.p = 8;
              _t3 = _context3.v;
              _iterator6.e(_t3);
            case 9:
              _context3.p = 9;
              _iterator6.f();
              return _context3.f(9);
            case 10:
              _context3.n = 2;
              break;
            case 11:
              _context3.n = 13;
              break;
            case 12:
              _context3.p = 12;
              _t4 = _context3.v;
              _iterator4.e(_t4);
            case 13:
              _context3.p = 13;
              _iterator4.f();
              return _context3.f(13);
            case 14:
              if (streams[0].localStream.getAudioTracks().length) {
                _context3.n = 23;
                break;
              }
              if (!this.localStream) {
                _context3.n = 22;
                break;
              }
              _iterator5 = _createForOfIteratorHelper(this.localStream.getTracks());
              _context3.p = 15;
              _iterator5.s();
            case 16:
              if ((_step5 = _iterator5.n()).done) {
                _context3.n = 19;
                break;
              }
              track = _step5.value;
              _context3.n = 17;
              return this.removeAudioTrack(track.id);
            case 17:
              track.stop();
            case 18:
              _context3.n = 16;
              break;
            case 19:
              _context3.n = 21;
              break;
            case 20:
              _context3.p = 20;
              _t5 = _context3.v;
              _iterator5.e(_t5);
            case 21:
              _context3.p = 21;
              _iterator5.f();
              return _context3.f(21);
            case 22:
              this.removeVideoBox();
            case 23:
              _context3.n = 46;
              break;
            case 24:
              if (!this.localStream) {
                _context3.n = 32;
                break;
              }
              _iterator7 = _createForOfIteratorHelper(this.localStream.getTracks());
              _context3.p = 25;
              _iterator7.s();
            case 26:
              if ((_step7 = _iterator7.n()).done) {
                _context3.n = 29;
                break;
              }
              _track2 = _step7.value;
              if (!(_track2.kind === 'audio')) {
                _context3.n = 28;
                break;
              }
              _context3.n = 27;
              return this.removeAudioTrack(_track2.id);
            case 27:
              _track2.stop();
            case 28:
              _context3.n = 26;
              break;
            case 29:
              _context3.n = 31;
              break;
            case 30:
              _context3.p = 30;
              _t6 = _context3.v;
              _iterator7.e(_t6);
            case 31:
              _context3.p = 31;
              _iterator7.f();
              return _context3.f(31);
            case 32:
              if (!this.additionalSources) {
                _context3.n = 45;
                break;
              }
              _iterator8 = _createForOfIteratorHelper(this.additionalSources);
              _context3.p = 33;
              _iterator8.s();
            case 34:
              if ((_step8 = _iterator8.n()).done) {
                _context3.n = 42;
                break;
              }
              _step8$value = _slicedToArray(_step8.value, 2), _key = _step8$value[0], _value = _step8$value[1];
              console.log(_key, _value.remoteStream.getAudioTracks());
              _iterator9 = _createForOfIteratorHelper(_value.remoteStream.getAudioTracks());
              _context3.p = 35;
              _iterator9.s();
            case 36:
              if ((_step9 = _iterator9.n()).done) {
                _context3.n = 38;
                break;
              }
              _track3 = _step9.value;
              _context3.n = 37;
              return this.removeAudioTrack(_track3.id);
            case 37:
              _context3.n = 36;
              break;
            case 38:
              _context3.n = 40;
              break;
            case 39:
              _context3.p = 39;
              _t7 = _context3.v;
              _iterator9.e(_t7);
            case 40:
              _context3.p = 40;
              _iterator9.f();
              return _context3.f(40);
            case 41:
              _context3.n = 34;
              break;
            case 42:
              _context3.n = 44;
              break;
            case 43:
              _context3.p = 43;
              _t8 = _context3.v;
              _iterator8.e(_t8);
            case 44:
              _context3.p = 44;
              _iterator8.f();
              return _context3.f(44);
            case 45:
              this.removeVideoBox();
            case 46:
              this.combinedStream.getTracks().forEach(function (track) {
                if (track.kind == 'audio') {
                  _this4.removeAudioTrack(track.id);
                }
                track.stop();
              });
              this.combinedStream = null;
              this.observer.disconnect();
              this.streamData = [];
              if (this.activeStreams) {
                this.activeStreams.forEach(function (_ref3) {
                  var source = _ref3.source,
                    gainNode = _ref3.gainNode;
                  source.disconnect();
                  gainNode.disconnect();
                });
                this.activeStreams.clear();
              }
              if (this.canvas && this.canvas.parentNode) {
                this.canvas.parentNode.removeChild(this.canvas);
              }
            case 47:
              return _context3.a(2);
          }
        }, _callee3, this, [[35, 39, 40, 41], [33, 43, 44, 45], [25, 30, 31, 32], [15, 20, 21, 22], [3, 8, 9, 10], [1, 12, 13, 14]]);
      }));
      function stopCaptureGameStream() {
        return _stopCaptureGameStream.apply(this, arguments);
      }
      return stopCaptureGameStream;
    }()
  }, {
    key: "getLocalAudio",
    value: function () {
      var _getLocalAudio = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this5 = this;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return navigator.mediaDevices.getUserMedia({
                audio: true
              });
            case 1:
              this.localStream = _context4.v;
              this.localStream.getAudioTracks().forEach(function (track) {
                console.log('processing audio track ', track);
                _this5.processAudioTrack(track);
              });
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function getLocalAudio() {
        return _getLocalAudio.apply(this, arguments);
      }
      return getLocalAudio;
    }()
  }, {
    key: "stopLocalAudio",
    value: function stopLocalAudio() {
      var _this6 = this;
      if (this.localStream) {
        this.localStream.getAudioTracks().forEach(function (track) {
          _this6.removeAudioTrack(track.id);
          track.stop();
        });
        this.localStream = null;
      }
    }
  }, {
    key: "getExistingStreams",
    value: function () {
      var _getExistingStreams = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(includeCamera) {
        var _this7 = this;
        var streams, _t9, _t0, _t1, _t10;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              streams = this.app.modules.getRespondTos('media-request');
              if (!(streams.length > 0)) {
                _context5.n = 1;
                break;
              }
              this.mediaRequestLocalStream = streams[0].localStream;
              this.additionalSources = streams[0].remoteStreams;
              this.mediaRequestLocalStream.getAudioTracks().forEach(function (track) {
                console.log('processing audio track ', track);
                _this7.processAudioTrack(track);
              });
              this.additionalSources.forEach(function (values, keys) {
                console.log(keys, values.remoteStream.getAudioTracks());
                values.remoteStream.getAudioTracks().forEach(function (track) {
                  _this7.processAudioTrack(track);
                });
              });
              _context5.n = 10;
              break;
            case 1:
              _context5.p = 1;
              if (!includeCamera) {
                _context5.n = 6;
                break;
              }
              _context5.p = 2;
              this.getLocalAudio();
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t9 = _context5.v;
              console.error('Failed to get user media:', _t9);
              alert('Failed to access camera and microphone.');
              return _context5.a(2);
            case 4:
              _context5.n = 5;
              return this.getOrCreateVideoBox(this.mod.publicKey);
            case 5:
              _context5.n = 8;
              break;
            case 6:
              _context5.p = 6;
              this.getLocalAudio();
              _context5.n = 8;
              break;
            case 7:
              _context5.p = 7;
              _t0 = _context5.v;
              console.error('Failed to get user media:', _t0);
              alert('Failed to access camera and microphone.');
              return _context5.a(2);
            case 8:
              _context5.n = 10;
              break;
            case 9:
              _context5.p = 9;
              _t1 = _context5.v;
              console.error('Access to user media denied: ', _t1);
              salert('Recording will continue without camera and/or microphone input');
            case 10:
              _context5.n = 12;
              break;
            case 11:
              _context5.p = 11;
              _t10 = _context5.v;
              console.error('Error in getExistingStreams:', _t10);
              throw _t10;
            case 12:
              return _context5.a(2);
          }
        }, _callee5, this, [[6, 7], [2, 3], [1, 9], [0, 11]]);
      }));
      function getExistingStreams(_x2) {
        return _getExistingStreams.apply(this, arguments);
      }
      return getExistingStreams;
    }()
  }, {
    key: "getOrCreateVideoBox",
    value: function () {
      var _getOrCreateVideoBox = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(publicKey) {
        var streams, stream_id, videoElement;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (this.videoBox) {
                _context6.n = 3;
                break;
              }
              streams = this.app.modules.getRespondTos('media-request');
              if (!(streams.length > 0)) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              _context6.n = 2;
              return navigator.mediaDevices.getUserMedia({
                video: true
              });
            case 2:
              this.videoBoxStream = _context6.v;
              stream_id = "stream_".concat(publicKey);
              this.videoBox = new SaitoVideoBox(this.app, this, publicKey);
              this.videoBox.render(this.videoBoxStream);
              videoElement = document.querySelector('.saito-videobox');
              if (videoElement) {
                videoElement.style.position = 'absolute';
                videoElement.style.top = '100px';
                videoElement.style.width = '350px';
                videoElement.style.height = '350px';
                videoElement.style.resize = 'both';
                videoElement.style.overflow = 'auto';
                videoElement.classList.add('game-video-box');
                this.app.browser.makeDraggable(stream_id);
              }
            case 3:
              return _context6.a(2, this.videoBox);
          }
        }, _callee6, this);
      }));
      function getOrCreateVideoBox(_x3) {
        return _getOrCreateVideoBox.apply(this, arguments);
      }
      return getOrCreateVideoBox;
    }()
  }, {
    key: "removeVideoBox",
    value: function removeVideoBox() {
      var forceRemove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!forceRemove) {
        if (this.is_recording_game || this.is_streaming_game) {
          return;
        }
        if (this.videoBox) {
          this.videoBoxStream.getTracks().forEach(function (track) {
            track.stop();
          });
          this.videoBoxStream = null;
          this.videoBox.remove();
          this.videoBox = null;
        }
      } else {
        if (this.videoBox) {
          this.videoBoxStream.getTracks().forEach(function (track) {
            track.stop();
          });
          this.videoBoxStream = null;
          this.videoBox.remove();
          this.videoBox = null;
        }
      }
    }
  }]);
}();
module.exports = StreamCapturer;